<template>
  <div class="pc-col">
    <div class="pc-col__option">
      {{ col.name || 'Column Name' }}
      <div>
        {{ sum }}
      </div>
      <div v-html="colOS">
      </div>
      <button>
        <font-awesome-icon icon="ellipsis-v" />
      </button>
    </div>
    <draggable :list="col.parts" group="pc" :class="col.meta.theme + ' pc-col__list'">
      <pc-parts v-for="(part, i) in col.parts" :part="part" :key="i" />
    </draggable>
  </div>
</template>

<script>
import PcParts from './PcParts.vue'
import draggable from 'vuedraggable'

export default {
  name: 'PcCol',
  props: ['col'],
  components: {
    draggable,
    'pc-parts': PcParts
  },
  computed: {
    sum(){
      var temp = 0;
      this.col.parts.forEach(curr=>{
        if ( Number.isInteger(curr.price) ){
          temp += Number(curr.price)
        }
      })
      return temp;
    },
    colOS(){
      return `<i class="fab fa-windows"></i>`;
    }
  }
}
</script>

<style lang="scss">

.pc-col__list {
  display: flex;
  flex-direction: column;
}

.pc-col__option{
  height: 80px;
  background-color: #999;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  margin: 0 10px;
}
</style>
